import React from 'react';
import type { BapAd } from '../../../types';

type BapOrganisationProps = {
    ad: BapAd;
    className?: string;
};

export function BapOrganisation(props: BapOrganisationProps) {
    const { ad, className = '' } = props;

    const privateLabel = ad.labels
        ?.filter((label) => label.type === 'SECONDARY')
        .find((label) => label.id === 'private');

    const unregisteredDealerLabel = ad.labels
        ?.filter((label) => label.type === 'SECONDARY')
        .find((label) => label.id === 'retailer_without_agreement');

    let organisationText;
    if (privateLabel) {
        organisationText = privateLabel.text;
    } else if (unregisteredDealerLabel) {
        organisationText = unregisteredDealerLabel.text;
    } else if (
        !privateLabel &&
        !unregisteredDealerLabel &&
        ad.organisation_name
    ) {
        organisationText = ad.organisation_name;
    }

    if (!organisationText) {
        return null;
    }
    return (
        <div className={`${className} text-xs s-text-subtle`}>
            <span>{organisationText}</span>
        </div>
    );
}
